export default __webpack_public_path__ + "static/media/etanorm.ea567c1a.png";